import style from './style.module.less';

export const EmptyStateIcon = () => (
  <svg className={style.icon} fill='none' height='80' viewBox='0 0 80 80' width='80' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M73.75 70H6.25V67.5C11.7625 67.5 16.25 63.0125 16.25 57.5V35.5375C16.25 22.6 26.5125 11.7125 39.1375 11.2625C45.65 11.025 51.8125 13.3875 56.4875 17.9C61.1625 22.4125 63.75 28.4875 63.75 34.9875V57.4875C63.75 63 68.2375 67.4875 73.75 67.4875V69.9875V70ZM13.7375 67.5H66.25C63.2125 65.2125 61.2375 61.5875 61.2375 57.5V35C61.2375 29.175 58.925 23.75 54.7375 19.7125C50.55 15.675 45.0375 13.5625 39.2125 13.775C27.925 14.175 18.7375 23.95 18.7375 35.55V57.5125C18.7375 61.6 16.7625 65.225 13.725 67.5125L13.7375 67.5Z'
      fill='#11003A'
    />
    <path d='M41.25 5H38.75V12.5H41.25V5Z' fill='#11003A' />
    <path d='M41.25 68.75H38.75V75H41.25V68.75Z' fill='#11003A' />
    <path
      d='M58.75 33.75C66.3439 33.75 72.5 27.5939 72.5 20C72.5 12.4061 66.3439 6.25 58.75 6.25C51.1561 6.25 45 12.4061 45 20C45 27.5939 51.1561 33.75 58.75 33.75Z'
      fill='#00E664'
    />
    <path
      d='M58.75 35C50.475 35 43.75 28.275 43.75 20C43.75 11.725 50.475 5 58.75 5C67.025 5 73.75 11.725 73.75 20C73.75 28.275 67.025 35 58.75 35ZM58.75 7.5C51.8625 7.5 46.25 13.1125 46.25 20C46.25 26.8875 51.8625 32.5 58.75 32.5C65.6375 32.5 71.25 26.8875 71.25 20C71.25 13.1125 65.6375 7.5 58.75 7.5Z'
      fill='#00E664'
    />
  </svg>
);
